import {Component} from '@angular/core';
import {Bonus} from '../../model/bonus.model';
import {ActivatedRoute, Router} from '@angular/router';
import {StateService} from '../../state.service';
import {Field} from '../../model/field.model';

@Component({
    selector: 'app-edit-bonus',
    templateUrl: './edit-bonus.component.html',
    styleUrls: ['./edit-bonus.component.css'],
    standalone: false
})
export class EditBonusComponent {
  truffleTypes = ['Burgunder', 'Perigordtrüffel', 'Wintertrüffel', 'Frühlingstrüffel', 'Teertrüffel', 'Grosssporigetrüffel'];
  bonus = new Bonus();
  submitted = false;
  fields: Field[];

  constructor(private route: ActivatedRoute, private router: Router, private stateService: StateService) {
    if (!this.stateService.bonus) {
      this.router.navigate( ['bonus']);
    }
    this.fields = this.stateService.fields;
    this.bonus = stateService.bonus;
  }

  onSubmit() {
    this.stateService.editBonus(this.bonus);
    this.submitted = true;
    this.router.navigate( ['bonus']);
  }

}
